const isSearchPage = () => window.location.pathname.includes("search")
export default isSearchPage
